import { DeleteOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { MazakaButton } from "apps/Common/MazakaButton";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import { deleteAccount } from "../Services";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import { handleSetUserInfoes } from "../ClientSideStates";
import { Modal } from "antd";
import { useNavigate } from "react-router-dom";

const DeleteAccount = () => {
    const { userInfoes } = useSelector((state: RootState) => state.profile);
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const handleDeleteAccount = async()=>{
          try {
              const response: any = await deleteAccount(userInfoes?.id);
              localStorage.removeItem("access_token",);
               dispatch(handleSetUserInfoes({data:null}))
              openNotificationWithIcon("default",response.message )
              navigate("/")
    
            } catch (error: any) {
          
              openNotificationWithIcon(
                "error",
                error?.message 
              );
        
              console.log("Somethings wrong during login to dashboard", error);
            }

    }
    const confirm = (record: any) => {
        Modal.confirm({
          title: "Uyarı",
          icon: <ExclamationCircleOutlined />,
          content: `Hesabınız Silinecek. Onaylıyor musunuz?`,
          okText: "Sil",
          cancelText: "Vazgeç",
          onOk: async () => {
            handleDeleteAccount()
          },
        });
      };
    return ( <>
    
    <MazakaButton htmlType="button" onClick={confirm} type="text" className='!text-gray-400 hover:!bg-red-500  hover:!text-white'  icon={<DeleteOutlined  className='' />} >
        Hesabımı Sil
      </MazakaButton>
    </> );
}
 
export default DeleteAccount;